import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Watchlist from '../views/app/watchlist.vue'
import Incident from '../views/app/incident.vue'
import AllIncidentsSearch from '../views/app/all-incidents-search.vue'
import Incidents from '../views/app/incidents.vue'
import WatchlistSettings from '../views/app/watchlist-settings.vue'
import WatchlistEdit from '../views/app/watchlist-edit.vue'
import PasswordReset from '../views/passwordReset.vue'
import CreateAccount from '../views/CreateAccount.vue'
import IncidentMap from '../views/app/incidentsMap.vue'
import newWatchlist from '../views/app/watchlist-new.vue'
import Account from '../views/app/account.vue'
import Contact from '../views/app/contact.vue'
import ForgotPassword from '../views/forgot-password.vue'
import GoPremium from '../views/app/goPremium.vue'
import PrivacyPolicy from '../views/privacy-policy.vue'
import Terms from '../views/terms.vue'
// import NotFound from '../views/404.vue'
Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/watchlist',
        name: 'Watchlist',
        component: Watchlist
    },
    {
        path: '/incident',
        name: 'Incident',
        component: Incident
    },
    {
        path: '/all-incidents-search',
        name: 'AllIncidentsSearch',
        component: AllIncidentsSearch
    },
    {
        path: '/incidents',
        name: 'Incidents',
        component: Incidents
    },
    {
        path: '/watchlist-settings',
        name: 'WatchlistSettings',
        component: WatchlistSettings
    },
    {
        path: '/watchlist-edit',
        name: 'WatchlistEdit',
        component: WatchlistEdit
    },
    {
        path: '/password-reset',
        name: 'PasswordReset',
        component: PasswordReset
    },
    {
        path: '/create-account',
        name: 'CreateAccount',
        component: CreateAccount
    },
    {
        path: '/incidentMap',
        name: 'IncidentMap',
        component: IncidentMap
    },
    {
        path: '/new-watchlist',
        name: 'newWatchlist',
        component: newWatchlist
    },
    {
        path: '/account',
        name: 'account',
        component: Account
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact
    },
    {
        path: '/forgotPassword',
        name: 'forgotPassword',
        component: ForgotPassword
    },
    {
        path: '/goPremium',
        name: 'goPremium',
        component: GoPremium
    },
    {
        path: '/privacy',
        name: 'privacyPolicy',
        component: PrivacyPolicy
    },
    {
        path: '/terms',
        name: 'Terms',
        component: Terms
    },
    {
        path: '*',
        name: 'NotFound',
        component: Home
    },
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

export default router